export default __webpack_public_path__ + "static/media/new-9.598c25d8.png";